import { Tooltip } from "@mui/material";
import { useMemo } from "react";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"
import { useProjetosHibridoStore } from "src/store/vendas/projetos/hibrido/hibrido.store";
import { FormProjetoHibridoType } from "src/store/vendas/projetos/hibrido/hibrido.types";
import { InputPrefix } from "./InputPrefix"

interface TaxaDescargaInputProps {
  errorState: string[];
  formState: FormProjetoHibridoType;
  onChangeValue: (formState: Partial<FormProjetoHibridoType>) => void;
}

export const TAXA_DESCARGA_OPTIONS = [{ id: 0.5, nome: "0,5C (Recomendado)" }, { id: 1, nome: '1,0C (Máximo)' }]

export const TaxaDescargaInput = ({ errorState, formState, onChangeValue }: TaxaDescargaInputProps) => {
  const projetosHibridoStoreState = useProjetosHibridoStore (store => store.state.data)

  const selecionadoSemBateria = useMemo(()=>{
    return projetosHibridoStoreState.tipo_bateria?.id === 0
  },[projetosHibridoStoreState.tipo_bateria?.id])

  const disabled = useMemo(() => {
    return !projetosHibridoStoreState.tipo_bateria?.id || selecionadoSemBateria;
  },[selecionadoSemBateria, projetosHibridoStoreState.tipo_bateria])

  return (
    <Tooltip title={selecionadoSemBateria ? "Indisponível para gerador sem bateria" : ""}>
      <span>
        <InputComboBoxList
          id={"hibrido-taxa-descarga-field"}
          key={`hibrido-taxa-descarga-field`}
          label={"* Taxa de descarga"}
          textField="nome"
          prefix={<InputPrefix />}
          valueField="id"
          // error={!!projetosHibridoStoreStateValidations.tipo_bateria.helper || errorState.includes('tipo_bateria')}
          // helperText={projetosHibridoStoreStateValidations.tipo_bateria.helper}
          options={TAXA_DESCARGA_OPTIONS}
          disabled={disabled}
          value={formState?.taxa_descarga || null}
          defaultValue={formState?.taxa_descarga || null}
          renderOptions={(option: any) => {
            return `${option?.nome}`
          }}
          disableClearable
          renderOptionsLabel={(option: any) => {
            return `${option?.nome}`
          }}
          onChange={(value) => {
            const payload = { taxa_descarga: value };
            
            onChangeValue(payload)
          }}
        />
      </span>
    </Tooltip>
  )
}